import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import YourTrustedWeldingExperts from "./sections/YourTrustedWeldingExperts";
import OurWeldingServices from "./sections/OurWeldingServices";
import WhyChooseRomeroWeldingInc from "./sections/WhyChooseRomeroWeldingInc";
import OurCommitmentToQuality from "./sections/OurCommitmentToQuality";
import StructuralSteelExpertise from "./sections/StructuralSteelExpertise";
import CustomMetalCreations from "./sections/CustomMetalCreations";
import WhatOurClientsSay from "./sections/WhatOurClientsSay";
import ContactUs from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <YourTrustedWeldingExperts />
      <OurWeldingServices />
      <WhyChooseRomeroWeldingInc />
      <OurCommitmentToQuality />
      <StructuralSteelExpertise />
      <CustomMetalCreations />
      <WhatOurClientsSay />
      <ContactUs />
    </div>;
}